/**
 * @author 3173
 * @description 证书管理 新增/编辑证书
 * @Date  2020/9/10
 */
import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool, utils_tool } from '../../../../tool';
import CertForm from './certForm'
import { formatAuth } from '@/utils/commonUtils';

let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool


class CertDetail extends WizContainer {
  componentName = 'certDetail';

  constructor(props) {
    super(props);
    const { history } = this.props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增';
    if (history.location && history.location.pathname === '/cert/certList/certUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        positionState = initialValue.state;
        Session.set('certUpd', initialValue)
      } else {
        initialValue = Session.get('certUpd') || {};
      }
      cardTitle = '编辑'
    }
    this.state = {
      cardTitle: cardTitle,
      formKey: 'certForm'
    }
    this.initialValue = initialValue;
  }

   /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
   _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/cert/certList/certUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('certUpd', initialValue)
      } else {
        initialValue = Session.get('certUpd') || {};
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this._componentDidMount()
    }
  }

  _componentDidMount() {
    if (this.initialValue.categoryIds) {
      this.doAction({
        path: 'categoryType/categoryList',
        payload: {
          key: "categoryList",
          apiParams: {
            type: 13,
            ids: this.initialValue.categoryIds
          }
        }
      });
    }
  }



  propsAndStateOnChange = {
    saveCert: this._saveCertOver.bind(this),
    categoryList: this._getCategoryListOver.bind(this)
  }


  _saveCertOver(nextProps, nextState) {
    if (nextProps.saveCert.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/cert/certList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveCert.msg);
    }
    return true;
  }

  _getCategoryListOver(nextProps, nextState) {
    if (nextProps.categoryList.code == 1) {
      let categoryList = nextProps.categoryList.data
      for (let i = 0; i < categoryList.length; i++) {
        categoryList[i].title = categoryList[i].name;
        categoryList[i].key = categoryList[i].id;
      }
      this.initialValue.categoryInfo = nextProps.categoryList.data
    }
    nextState.formKey = 'certForm' + new Date().getTime();
    return true;
  }

  /**
   * 保存/更新
   * @param values
   * @private
   */
  _saveCert(values) {
    const { history } = this.props;
    let apiPath = "cert/add";
    if (this.initialValue.id) {
      apiPath = "cert/update";
    }
    if (values.type && values.type.key) {
      values.type = values.type.key;
    }
    if (values.showValidTime === 0) {
      values.validTime = -1;
    }

    if (values.type && values.type.key) {
      values.type = values.type.key;
    }
    if (values && values['icon'] && values['icon'].length) {
      values.icon = values.icon[0].fileId;
    } else {
      values.icon = "";
    }
    //如果填了流水号或证书代码，也必须填另一个
    if (values.type === 1 && ((!values.serial && values.code) || (values.serial && !values.code))) {
      wizNotice.warn('证书代码与流水号需要一并输入')
      return;
    }

    // let authCmd = {}
    // if (values['authCmd']) {
    //   let authInfo = values['authCmd']
    //   authCmd.isAll = authInfo.isAll
    //   authCmd['orgIds'] = authInfo['orgIds'] && authInfo['orgIds'].map(p => (p.id))
    //   authCmd['positionIds'] = authInfo['positionIds'] && authInfo['positionIds'].map(p => (p.id))
    //   authCmd['positionCategoryIds'] = authInfo['positionCategoryIds'] && authInfo['positionCategoryIds'].map(p => (p.id))
    //   authCmd['personIds'] = authInfo['personIds'] && authInfo['personIds'].map(p => (p['id']))
    // }
    // values['authCmd'] = authCmd;

    values.authCmd = formatAuth(values.authCmd)

    this.doAction({
      path: apiPath,
      payload: {
        key: "saveCert",
        apiParams: {
          ...values,
          id: this.initialValue.id
        }
      }
    });
  }


  _render() {
    const { certLoading, categoryTypeLoading } = this.props;
    let { cardTitle, initialValue } = this.state;



    return <WizCard>
      <WizSpin tip={'加载中'} spinning={certLoading || categoryTypeLoading}>

        <CertForm className={'form-inline'} key={this.state.formKey} initialValue={this.initialValue}
          onSubmit={this._saveCert.bind(this)} />

      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { cert, categoryType } = state;
  const saveCert = modelUtils.getModelEntity(cert, "saveCert");
  const categoryList = modelUtils.getModelEntity(categoryType, "categoryList");
  const load = modelUtils.getLoadingState(state, ['cert', 'categoryType']);
  return {
    saveCert: saveCert,
    categoryList,
    ...load
  }
};

export default connect(mapStateToProps)(CertDetail);
